module.exports = __webpack_public_path__ + "static/img/serviceAct1.5ba9b887.png";